import React from "react";

function AnsweredIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 256 256"
    >
      <path
        fill="#ffa91a"
        d="M128 49.964c-35.899 0-65 29.101-65 65 0 20.304 9.31 39.943 23.893 53.575 9.169 8.571 12.908 19.179 17.079 30.769h48.056c4.172-11.591 7.91-22.198 17.079-30.769C183.69 154.906 193 135.267 193 114.963c0-35.898-29.102-64.999-65-64.999z"
        data-original="#ffa91a"
      ></path>
      <path
        fill="#ffc91d"
        d="M72.178 97.849a2 2 0 01-1.891-2.65c5.977-17.406 19.893-31.498 37.227-37.696a2 2 0 011.347 3.767c-16.199 5.792-29.205 18.962-34.79 35.229a2.006 2.006 0 01-1.893 1.35zm43.698-38.633a2.002 2.002 0 01-.409-3.958l.553-.113a2 2 0 11.791 3.921l-.523.107a1.995 1.995 0 01-.412.043z"
        data-original="#ffc91d"
      ></path>
      <path
        fill="#f79219"
        d="M168.68 64.283c8.952 11.138 14.32 25.279 14.32 40.68 0 20.304-9.31 39.943-23.893 53.575-8.293 7.752-12.144 17.17-15.89 27.475a5.002 5.002 0 01-4.699 3.295h-38.29c1.31 3.23 2.51 6.57 3.744 10h48.056c4.172-11.591 7.91-22.198 17.079-30.769C183.69 154.906 193 135.267 193 114.963c0-20.497-9.497-38.766-24.32-50.68z"
        data-original="#f79219"
      ></path>
      <path
        fill="#ef7816"
        d="M171.388 66.575C181.713 78.082 188 93.287 188 109.963c0 20.304-9.31 39.943-23.893 53.575-8.293 7.752-12.144 17.17-15.89 27.475a5.002 5.002 0 01-4.699 3.295h-41.362c.608 1.645 1.208 3.31 1.816 5h48.056c4.172-11.591 7.91-22.198 17.079-30.769C183.69 154.906 193 135.267 193 114.963c0-19.221-8.349-36.487-21.612-48.388z"
        data-original="#ef7816"
      ></path>
      <path
        fill="#827f7e"
        d="M128 241.996c5.564 0 10.074-4.51 10.074-10.074h-20.148c0 5.564 4.51 10.074 10.074 10.074z"
        data-original="#827f7e"
      ></path>
      <path
        fill="#58595b"
        d="M147.028 231.922h-38.056a5 5 0 01-5-5v-27.615h48.056v27.615a5 5 0 01-5 5z"
        data-original="#58595b"
      ></path>
      <path
        fill="#414042"
        d="M147.028 199.307v22.615a5 5 0 01-5 5h-38.056a5 5 0 005 5h38.056a5 5 0 005-5v-27.615z"
        data-original="#414042"
      ></path>
      <circle
        cx="128"
        cy="122.198"
        r="40"
        fill="#648940"
        data-original="#648940"
      ></circle>
      <circle
        cx="128"
        cy="122.198"
        r="30"
        fill="#91b56b"
        data-original="#91b56b"
      ></circle>
      <path
        fill="#76a34f"
        d="M146.56 98.638a29.86 29.86 0 016.44 18.56c0 16.569-13.431 30-30 30a29.86 29.86 0 01-18.56-6.44c5.494 6.964 14.002 11.44 23.56 11.44 16.569 0 30-13.431 30-30 0-9.559-4.476-18.067-11.44-23.56z"
        data-original="#76a34f"
      ></path>
      <path
        fill="#fff"
        d="M124.546 136.437a1.999 1.999 0 01-1.387-.559l-11.791-11.349a2 2 0 012.774-2.882l10.197 9.815 15.415-19.619a2.001 2.001 0 013.146 2.472l-16.781 21.357a2.004 2.004 0 01-1.573.765z"
        data-original="#ffffff"
      ></path>
      <path
        fill="#ffc91d"
        d="M128 41.67a4 4 0 01-4-4V14.004a4 4 0 018 0V37.67a4 4 0 01-4 4zm-78.167 78.167H26.167a4 4 0 010-8h23.667a4 4 0 11-.001 8zm180 0h-23.667a4 4 0 010-8h23.667a4 4 0 010 8zM88.92 52.144a3.998 3.998 0 01-3.468-2L73.619 29.647a4 4 0 016.928-4L92.38 46.143a4 4 0 01-3.46 6.001zm-28.618 28.61a3.977 3.977 0 01-1.996-.537L37.81 68.384a4 4 0 114-6.928L62.306 73.29a4 4 0 01-2.004 7.464zm155.885 90a3.977 3.977 0 01-1.996-.537l-20.496-11.833a4 4 0 114-6.928l20.496 11.833a4 4 0 01-2.004 7.465zM167.08 52.144a4 4 0 01-3.46-6l11.833-20.496a4 4 0 116.928 4l-11.833 20.496a4.001 4.001 0 01-3.468 2zm28.618 28.61a4 4 0 01-2.004-7.464l20.496-11.833a4 4 0 114 6.928l-20.496 11.833a3.979 3.979 0 01-1.996.536zm-155.885 90a4 4 0 01-2.004-7.464l20.496-11.833a4 4 0 114 6.928L41.81 170.218a3.98 3.98 0 01-1.997.536z"
        data-original="#ffc91d"
      ></path>
    </svg>
  );
}

export default AnsweredIcon;